import { useMemo } from 'react'
import { useMyMemberships } from './useMyMemberships'
import type { MyGym } from './useMyMemberships'

export type { MyGym }

/**
 * The gyms this member belongs to.
 *
 * The sidebar needs this because "do you have a gym" cannot be answered from
 * the URL, which names one only on gym routes, nor from the last gym opened,
 * which a newly approved member has never set. A selector over
 * `useMyMemberships` so it shares that one request and one cache entry.
 */
export function useMyGyms(): { gyms: MyGym[]; loading: boolean; refresh: () => Promise<void> } {
  const { memberships, loading, refresh } = useMyMemberships()

  const gyms = useMemo(() => {
    // A member can hold both a subscription and an approved join request at the
    // same gym, which arrive as two entries.
    const unique = new Map<string, MyGym>()
    for (const m of memberships) unique.set(m.gym.id, m.gym)
    return [...unique.values()]
  }, [memberships])

  return { gyms, loading, refresh }
}
